import { DefaultFooter } from '@ant-design/pro-components';
import defaultSettings from '@/../config/defaultSettings';
import React from 'react';

const Footer: React.FC = () => {
  return (

    <DefaultFooter
    copyright={defaultSettings.copyright}
    links={[
      {
        title: ``,
        href: '#',
        key: `footerLink`,
      },
    ]}
  />
  );
};

export default Footer;
